<template lang="pug" src="./patients.pug"></template>

<script>
import HeroPages from 'components/hero/hero-pages/hero-pages'
import CustomPatientVisit from 'components/custom/custom-patient-visit/custom-patient-visit'
import BannerIconTextButton from 'components/banner/banner-icon-text-button/banner-icon-text-button'
import CustomPatientsSmile from 'components/custom/custom-patients-smile/custom-patients-smile'
import RepeaterIconButton from 'components/repeater/repeater-icon-button/repeater-icon-button'

export default {
  computed: {
    props () {
      return this.$store.state.pages['patients']
    }
  },
  components: {
    HeroPages,
    CustomPatientVisit,
    BannerIconTextButton,
    CustomPatientsSmile,
    RepeaterIconButton
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/patients/patients.vue